import { render, staticRenderFns } from "./noteSta.vue?vue&type=template&id=50ce1577&scoped=true&"
import script from "./noteSta.vue?vue&type=script&lang=js&"
export * from "./noteSta.vue?vue&type=script&lang=js&"
import style0 from "./noteSta.vue?vue&type=style&index=0&id=50ce1577&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce1577",
  null
  
)

export default component.exports